import { ApiRoutes } from "../../../Constants/ApiRoutingConstants";
import axios, { AxiosInstance } from "axios";
import authorizeService from "../../Identity/Utilities/AuthorizeService";
import AccountSettingsReadDto from "../../../Models/Dashboard/AccountSettingsReadDto";

/**
 * This service provides implementations for http calls to the api pertaining to account settings functionality
 */

class AccountSettingsApiService {
  axiosInstance: AxiosInstance;
  constructor() {
    //Subscribe to identity store the get token
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_EVENT_SERVICE_URL,
    });
  }

  async getAccountSettings(): Promise<AccountSettingsReadDto> {
    const response = await this.axiosInstance({
      method: "GET",
      //@ts-ignore
      url: `${ApiRoutes.AccountSettings}`,
      headers: {
        Authorization: `Bearer ${(await authorizeService.getUser()).access_token}`,
      },
    })
    return response.data;
  }
}

const accountSettingsApiService = new AccountSettingsApiService();
export default accountSettingsApiService;

